import { Box, Flex, Text } from '@chakra-ui/react'
import type { Product } from '@twlvxtwlv/tokenforge'
import NextLink from 'next/link'
import { ProductImage } from '../../../../../shared/cards/product-card/image/product-image'

interface TokenThumbnailProps {
  product: Product
  imageSize?: string
}

export function ProductThumbnail({ product, imageSize = '200px' }: TokenThumbnailProps) {
  return (
    <NextLink href={`/nft/${product.code}`} passHref>
      <Flex direction="column" _hover={{ cursor: 'pointer' }} maxW={'500px'}>
        <Box bg="txtBlack" px={1} py={1}>
          <Text
            w="full"
            fontSize={[10, 10, 12, 12, 12, 14]}
            casing="uppercase"
            color="white"
            whiteSpace="nowrap"
            overflowX="hidden"
            textOverflow="ellipsis"
          >
            {product.name}
          </Text>
        </Box>
        <ProductImage product={product} size="s-big" imageSize={imageSize} />
      </Flex>
    </NextLink>
  )
}
